const Labels = {
  ENGLISH: "English",
  RHNILOGY_REVIEW_SYSTEM: "Rhinology Review System",
  EMAIL: "Email",
  EMAIL_ADDRESS: "Email address",
  ORDER: "Order",
  PASSWORD: "Password",
  LOGIN: "Login",
  LOGIN_AS: "Login as",
  LOGOUT: "Logout",
  REGISTRATION: "Registration",
  FORGOT_PASSWORD: "Forgot your password?",
  CANCEL: "Cancel",
  REGISTER: "Register",
  FIRSTNAME: "First name",
  MIDDLENAME: "Middle name",
  LASTNAME: "Last name",
  ORCID: "ORCID",
  TITLE: "Title",
  DEPARTMENT: "Department",
  DIVISION: "Division",
  INSTITUTE: "Institute",
  COUNTRY: "Country",
  CITY: "City",
  STREET_NAME: "Street name",
  POSTAL_CODE: "Postal code",
  PHONE_NUMBER: "Phone number",
  REPEAT_EMAIL_ADDRESS: "Repeat Email adress",
  REPEAT_PASSWORD: "Repeat Password",
  AREAS_OF_EXPERTISE: "Areas of expertise",
  PROFILE: "Profile",
  SAVE: "Save",
  ORCID_MASK: "xxxx-xxxx-xxxx-xxxx",
  FIRSTNAME_REQUIRED: "Firstname is required",
  MAILTO_REQUIRED: "Mail to is required",
  LASTNAME_REQUIRED: "Lastname is required",
  ORCID_REQUIRED: "ORCID is required",
  EMAIL_REQUIRED: "Email is required",
  EMAIL_REPEAT_REQUIRED: "Email repeat is required",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_REPEAT_REQUIRED: "Password repeat is required",
  TITLE_REQUIRED: "Title is required",
  EMAIL_DO_NOT_MATCH: "Emails do not match",
  PASSWORDS_DO_NOT_MATCH: "Passwords do not match",
  PLACEHOLDER_POSTAL_CODE: "W12 0PG",
  MANUSCRIPTS: "Manuscripts",
  VIEW: "View",
  DRAFT: "Draft",
  SUBMIT: "Submit",
  TICKETS: "Tickets",
  REVIEW_HISTORY: "Reviewer history",
  TO_DO_LIST: "To do list",
  AUTHOR: "Author",
  AUTHORS: "Authors",
  REVIEWER: "Reviewer",
  REVIEWERS: "Reviewers",
  PAPER_FILES: "Paper files",
  OVERVIEW: "Overview",
  BACK: "Back",
  RESET: "Reset",
  FINISHED_STEPPER: "All steps completed!",
  FINISH: "Finish",
  NEXT: "Next",
  UNKNOWN_STEP: "Unknown step. Error!",
  REGISTER_SUCCESS: "Registration successfully completed.",
  EDIT_USER_SUCCESS: "Profile updated successfully.",
  SUCCESSFULLY_ADDED: "Successfully added",
  SUCCESSFULLY_DELETED: "Successfully deleted",
  SUCCESSFULLY_UPDATED: "Successfully updated",
  GENERAL_INFORMATION: "General (Main) info",
  COVER_LETTER: "Running title",
  FIRST_TIME_CLASSIFICATION: "Manuscript Classification",
  FIRST_TIME: "Has the manuscript been sent as an original contribution before?",
  PREVIOUS_ID: "Id of previously submitted manuscript ",
  KEYWORDS: "Keywords",
  ALL_KEYWORDS: "All Keywords",
  SELECTED_KEYWORDS: "Selected Keywords",
  ABSTRACT: "Abstract",
  COPY_ITEMS: "Please keep in mind that you can copy paste any text from your text-editor into these fieds",
  YES: "Yes",
  NO: "No",
  ADD: "Add",
  EDIT: "Edit",
  CHANGE_GROUP: "Change group",
  REMOVE: "Remove",
  SEARCH: "Search",
  ADDED_AUTHORS: "Already added authors:",
  RESULTS: "Results",
  SEARCH_AUTHOR: "Search for an author",
  REVIEWER_1_NAME: "Reviewer #1 name",
  REVIEWER_2_NAME: "Reviewer #2 name",
  EXCLUDED: "Excluded",
  REVIEWER_1: "Reviewer #1",
  REVIEWER_2: "Reviewer #2",
  REVIEWER_EXCLUDED: "Excluded reviewer",
  REVIEWER_1_RELATIONSHIP: "Reviewer #1 relationship",
  REVIEWER_2_RELATIONSHIP: "Reviewer #2 relationship",
  UPDATE: "Update",
  FILTER: "Filter",
  NO_RESULTS: "No results to display...",
  NOTE: "Note",
  MANUSCRIPT_FIGURES: "Manuscript and figures",
  NAME: "Name",
  STATUS: "Status",
  DELETE: "Delete",
  SUBJECT: "Subject",
  SUBJECT_PLACEHOLDER: "Please, indicate manuscript number within the title",
  TICKET_HELP:
    "If you have any problems using the Rhinology Review system you may submit a ticket and you will receive a response as soon as possible",
  NEW_TICKET: "New Ticket",
  ADD_KEYWORD: "Add keyword",
  SEARCH_KEYWORD: "Search keyword",
  SEND: "Send",
  NEW_TICKET_HELP: "If you have a problem with the website you can submit a ticket here.",
  EDITOR: "Editor",
  ALL_MANUSCRIPT: "All Manuscripts",
  MY_MANUSCRIPT: "My manuscripts",
  ACTIVE_MANUSCRIPT: "Active Manuscripts",
  ARCHIVE: "Archive",
  ALL_REVIEWERS: "All reviewers",
  KEYWORD: "Keywords",
  USERS: "Users",
  REVIEWERS_STATISTICS: "Reviewers statistics",
  ASSOCIATE_STATISTICS: "Associate statistics",
  ASSISTANT_EDITOR: "Assistant Editor",
  ACCEPTED_MANUSCRIPTS: "Accepted manuscripts",
  SEARCH_MANUSCRIPTS: "Search manuscripts",
  BLACKLIST_AUTHORS: "Blacklist authors",
  ALL_ASSOCIATE_EDITORS: "All associate editors",
  CLOSE: "Close",
  AWAITING_RESPONSE: "Awaiting response",
  OPEN: "Open",
  CLOSED: "Closed",
  BUG: "Bug",
  REQUEST: "Request",
  GENERAL: "General",
  QUESTION_CLOSE_TICKET: "Are you sure you want to close ticket?",
  CLOSED_TICKET: "Closed ticket",
  DIALOG_ERROR: "Confirm dialog error",
  PENDING_TICKETS: "Pending tickets",
  TICKETS_ANSWERING: "Tickets that need answering",
  TICKET: "Ticket",
  TYPE: "Article type",
  NAME_REQUIRED: "Name is required",
  CONTENT_REQUIRED: "Content is required",
  TYPE_REQUIRED: "Type is required",
  FILE_NAME: "File name",
  FILE_DESIGNATION: "File designation",
  FILE_TYPE: "File type",
  FILE_UPLOAD: "File Upload",
  SIZE: "Size",
  COMMENTS: "Comments",
  UPLOAD: "Upload",
  UPLOAD_BY_USER: "Uploaded by user",
  MANUSCRIPT: "Manuscript",
  FIGURE: "Figure",
  SUPPLEMENTARY_FIGURE: "Supplementary figure",
  ADDITIONAL_FILE: "Additional file",
  VIDEO_FILE: "Video file",
  TABLES: "Tables",
  YOU_WANT_TO_MOVE_ON: "Are you sure you want to move on?",
  PICTURE_IS_UPLOADED: "No picture has been uploaded",
  RELATIONSHIP: "Relationship",
  MANUSCRIPT_CLASSIFICATION: "Manuscript Classification",
  EDIT_KEYWORD: "Edit keyword",
  NEW_KEYWORD: "New keyword",
  ARTICLE_NUMBER: "Article number",
  REVISION_NUMBER: "Revision number",
  SHORT_REASON: "Short reason",
  ROLE: "Role",
  DETAILS: "Details",
  ADD_REVIEWER: "Add reviewer",
  GROUPS: "Groups",
  EDIT_USER: "Edit user",
  EXPERTISE: "Expertise",
  UPDATE_AREAS_OF_EXPERTISE: "Update areas of expertise",
  RENAME: "Rename",
  REVIEW_STATUS: "Review status",
  AUTHOR_FIRSTNAME: "Author - Firstname",
  AUTHOR_LASTNAME: "Author - Lastname",
  ARTICLE_ID: "Article Id",
  NEW_ARTICLE: "New Article",
  REJECTED: "Rejected",
  ACCEPTED: "Accepted",
  MAJOR_REVISION: "Major revision",
  MINOR_REVISION: "Minor revision",
  REVIEWED: "Reviewed",
  UNDER_REVIEW: "Under Review",
  REVIEWER_SELECTION: "Reviewer Selection",
  DIRECT_REJECT: "Direct Reject",
  CORRECTION: "Correction",
  REJECTED_R0: "Rejected RO",
  DIRECT_REJECT_R0: "Direct Reject RO",
  REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR: "Reject and resubmit as a letter to the editor",
  ASSOCIATE_EDITOR: "Associate Editor",
  RETURNED_TO_EDITOR: "Returned to Editor",
  ASSOC_EDITOR: "Assoc. Editor",
  ASSOC_EDITOR_DECISION: "Assoc. Editor Decision",
  SUBMITTED_ON: "Submitted",
  LAST_UPDATE: "Last update",
  FULL_ARTICLE: "Full article",
  FULL: "Full",
  ORIGINAL_FILES: "Original Files",
  ORIGINAL: "Original",
  COVER: "Cover",
  RESPONSE_TIME: "Response time",
  COMPLETED: "Completed",
  REFUSED: "Refused",
  REFUSED_PERCENTAGE: "Refused %",
  RATING: "Rating",
  DATE: "Date",
  DATE_FROM: "Date from",
  DATE_TO: "Date to",
  ACTION: "Action",
  OVERRIDE: "Override",
  ASSIGN_REVIEWERS: "Assign reviewers",
  DECIDE_ON_STATUS: "Decide on Status",
  OVERDUE_REVIEWERS: "Overdue Reviewers",
  OVERDUE_AES: "Overdue AEs",
  REQUIRED_REVIEWERS: "Required reviewers",
  ASSIGNED_REVIEWERS: "Assigned reviewers",
  ASSIGN_NEW_REVIEWERS: "Assign new reviewers",
  LETTER_TO_THE_EDITOR: "Letter to the editor",
  TO_ASSOCIATE_EDITOR: "Associate Editor",
  MAIL_ALL: "Mail all",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  CUSTOM: "Custom",
  MAKE_DECISION: "Make decision",
  SEND_MAIL_TO_ALL: "Send mail to all?",
  SEND_MAIL: "Send mail",
  MAIL_SENT: "Mail has been sent",
  TO: "To",
  CC: "CC",
  MESSAGE: "Message",
  NEW_EMAIL: "New email",
  SEND_THANKS_CHANGE_STATUS: "This will send the thank you mails to the reviewers and change the paper status",
  CURRENT_ASSIGNMENTS: "Current Assignments",
  ASSIGNMENTS_LAST_YEAR: "Assignments last 12 months",
  COMPLETED_LAST_YEAR: "Completed last 12 months",
  RESPONSE_TIME_DAYS: "Response time (days)",
  ACTIVE_ASSIGNMENTS: "Active assignments",
  SELECT_STATUS: "Select status",
  MAILTO: "To",
  ARTICLE_STATUS: "Article status",
  CHECK_MANUSCRIPT: "Check manuscript",
  REJECT: "Reject",
  PLACEHOLDER_WRITE_COMMENT: "Write a comment...",
  ACCEPT: "Accept",
  DECLINE: "Decline",
  REVIEW: "Review",
  REVIEW_REQUESTS: "Review Requests",
  PENDING_REVIEWS: "Pending Reviews",
  NOTES: "Notes",
  LOG: "Log",
  EMAIL_LOG: "Email log",
  REVIEWS: "Reviews",
  ARTICLE_DETAILS: "Article details",
  REVISION: "Revision",
  SELECTED_ON: "Selected on",
  MAILED_ON: "Mailed on",
  DECIDED_ON: "Decided on",
  COMPLETED_ON: "Completed on",
  NO_REVIEWERS_REVISION: "There are no reviewers assigned for this revision.",
  ADJUST_MANUSCRIPT: "Adjust manuscript",
  UPLOAD_REVISION: "Upload revision",
  INSTRUCTIONS: "Instructions",
  MANUSCRIPT_INFORMATION: "Manuscript information",
  REVISION_UPLOAD: "Revision upload",
  FULLNAME: "Full name",
  FULLNAME_REQUIRED: "Full name required",
  SUGGEST_REVIEWER: "Suggest new reviewers",
  SENIOR: "Senior",
  MEDIOR: "Medior",
  JUNIOR: "Junior",
  SENIORITY: "Seniority",
  STATUS_CHANGE: "Status change",
  REVIEWER_ASSIGNMENT: "Reviewer assignment",
  REVIEWER_ASSIGNMENT_REMOVED: "Reviewer assignment removed",
  REVIEWER_MAILED: "Reviewer mailed",
  REVIEWER_ANSWER: "Reviewer answer",
  REVIEWER_DECISION: "Reviewer decision",
  AE_ASSIGNMENT: "AE assignment",
  AE_DECISION: "AE decision",
  ASSISTANT_DECISION: "Assistant decision",
  EDITOR_DECISION: "Editor decision",
  PUBLISHED_LAST_36_MONTHS: "Published last 36 months",
};
export default Labels;
